import { request } from 'utils/request';

import { errorFromException } from 'errors';

import { TransactionableTypes } from './index';

export const captureTransaction = async (
  transactionable: TransactionableTypes,
  transactionablePublicId: string,
) => {
  try {
    const { data } = await request.post<{ redirect_to: string }>(
      `/api/internal/${transactionable}/${transactionablePublicId}/transactions/capture`,
    );
    return { data, error: undefined };
  } catch (e) {
    return errorFromException(e, 'Unable to pay.');
  }
};
